import * as React from 'react';
import { useEffect, useState } from 'react';
import wrapStore from '@src/utils/wrap-store';
import AdvantageStore from '@src/business-components/kv-box/store';
import styles from './index.less';
import cx from 'classnames';

const AdvantagePage = ({ store }) => { 
  store.use();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (!isVisible) {
            setIsVisible(true);
            observer.disconnect(); // 一旦显示就停止观察
          }
        }
      },
      {
        threshold: 0.1 // 当10%的元素可见时触发
      }
    );

    const element = document.getElementById('advantage');
    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className={cx(styles.root, 'section')} id="advantage">  
      <div className={styles.box}> 
        <div className={cx(styles.title, { [styles.visible]: isVisible })}>我们的合作优势</div>
        <div className={cx(styles.content, { [styles.visible]: isVisible })}>
          {store.list.map((item, index) => {
            return (
              <div className={styles.item} key={index}> 
                <div className={styles.img} style={{ backgroundImage: `url(${item.icon})` }} />
                <div className={styles.itTitle}>{item.part2_title}</div>
                <div className={styles.desc}>{item.content}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default wrapStore(AdvantagePage, AdvantageStore);
